import { Link, Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { BrainCircuit } from "lucide-react";
import { z } from "zod";

export const Route = createFileRoute("/_auth")({
  validateSearch: z.object({
    redirect: z.string().optional(),
  }),
  beforeLoad: ({ context, location }) => {
    if (context.auth.loading) return;

    const allowAuthenticatedAccess = ["/reset-password", "/verify-email"].includes(location.pathname);
    if (context.auth.isAuthenticated && !allowAuthenticatedAccess) {
      throw redirect({ to: "/dashboard" });
    }
  },
  component: AuthLayout,
});

function AuthLayout() {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center bg-linear-to-br from-blue-50 via-white to-purple-50 px-4 py-8 dark:from-blue-950/40 dark:via-background dark:to-purple-950/40">
      <Link
        to="/"
        className="mb-8 flex flex-col items-center gap-2 transition-opacity hover:opacity-90"
      >
        <div className="flex size-12 items-center justify-center rounded-xl bg-linear-to-br from-blue-600 to-purple-600 text-white shadow-lg">
          <BrainCircuit className="size-6" />
        </div>
        <span className="text-xl font-bold tracking-tight">CBEET</span>
      </Link>
      <div className="w-full max-w-sm">
        <Outlet />
      </div>
    </div>
  );
}
